import React from "react";
import { connect } from "react-redux";
import { applySpec } from "ramda";
import {
  contributorDialogFieldBlurred,
  contributorDialogFieldChanged,
  contributorDialogRoleChanged,
  saveEditContributor,
  hideContributorDialog,
} from "edit-media/redux/editMediaActions";
import {
  getContributorDialogDisableSave,
  getEditContributorDialogVisible,
  getContributorDialogErrors,
  getContributorDialogFields,
  getContributorRoles,
  getContributorTypes,
} from "common/selectors";
import ContributorDialog from "edit-media/components/ContributorDialog";

const EditContributorDialog = ({
  contributorTypes,
  contributorRoles,
  disableSave,
  errors,
  fields,
  onBlur,
  onCancel,
  onFieldChange,
  onRoleChange,
  onSave,
  title,
  visible,
}) => (
  <ContributorDialog
    title={"Edit Contributor"}
    contributorRoles={contributorRoles}
    contributorTypes={contributorTypes}
    disableSave={disableSave}
    errors={errors}
    fields={fields}
    onBlur={onBlur}
    onCancel={onCancel}
    onFieldChange={onFieldChange}
    onRoleChange={onRoleChange}
    onSave={onSave}
    saveText={"Update"}
    visible={visible}
  />
);

const mapState = applySpec({
  visible: getEditContributorDialogVisible,
  fields: getContributorDialogFields,
  errors: getContributorDialogErrors,
  contributorRoles: getContributorRoles,
  contributorTypes: getContributorTypes,
  disableSave: getContributorDialogDisableSave,
});

const mapDispatch = dispatch => ({
  onBlur: (field, value) => () =>
    dispatch(contributorDialogFieldBlurred(field, value)),
  onCancel: () => dispatch(hideContributorDialog()),
  onFieldChange: path => value =>
    dispatch(contributorDialogFieldChanged(path, value)),
  onRoleChange: id => dispatch(contributorDialogRoleChanged(id)),
  onSave: id => dispatch(saveEditContributor()),
});

export default connect(mapState, mapDispatch)(EditContributorDialog);
